import React from 'react';

const LoadingScreen = () => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: 'var(--background-color)'
  }}>
    <div style={{
      border: '4px solid rgba(0, 0, 0, 0.1)',
      borderRadius: '50%',
      borderTop: '4px solid var(--primary-color)',
      width: '50px',
      height: '50px',
      animation: 'spin 1s linear infinite',
      marginBottom: '1rem'
    }} />
    <p style={{ color: 'var(--gray-600)', fontSize: '1rem' }}>
      جاري التحميل...
    </p>
    <style>
      {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
    </style>
  </div>
);

export default LoadingScreen; 